import { render, staticRenderFns } from "./GestioneAttivitaClientiListComponent.vue?vue&type=template&id=4ce13b12"
import script from "./GestioneAttivitaClientiListComponent.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaClientiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports